import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
	providedIn: 'root'
})
export class StorageService {
	private _storage: Storage | null = null;

	constructor(
		private storage: Storage
	) {
		this.init();
	}

	public wakeup() {
		// Empty method to wake up service and trigger the constructor
	}

	/**
	 * Initializes the storage if not already initialized.
	 */
	async init() {
		if (!this._storage) {
			const storage = await this.storage.create();
			this._storage = storage;
		}
	}

	/**
	 * Ensures that the storage is ready before any operation.
	 */
	private async ensureReady() {
		if (!this._storage) {
			await this.init();
		}
	}

	/**
	 * Retrieves a value by key from storage.
	 * 
	 * @param key 
	 * @returns promise
	 */
	public async get(key: string): Promise<any> {
		await this.ensureReady();
		return this._storage?.get(key);
	}

	/**
	 * Saves a key-value pair in storage.
	 * 
	 * @param key 
	 * @param value 
	 * @returns promise
	 */
	public async set(key: string, value: any): Promise<any> {
		await this.ensureReady();
		return this._storage?.set(key, value);
	}

	/**
	 * Removes a key from storage.
	 * 
	 * @param key 
	 * @returns promise
	 */
	public async remove(key: string): Promise<any> {
		await this.ensureReady();
		return this._storage?.remove(key);
	}

	/**
	 * Retrieves all keys from storage.
	 * 
	 * @returns promise
	 */
	public async all(): Promise<any> {
		await this.ensureReady();
		return this._storage?.keys();
	}
}
